import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactListItem = ({ 
  contact, 
  isSelected, 
  onSelect, 
  onCall, 
  onEdit, 
  isCompact = false 
}) => {
  const formatLastContact = (date) => {
    const now = new Date();
    const contactDate = new Date(date);
    const diffTime = Math.abs(now - contactDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 1) return 'Bugün';
    if (diffDays === 2) return 'Dün';
    if (diffDays <= 7) return `${diffDays} gün önce`;
    if (diffDays <= 30) return `${Math.ceil(diffDays / 7)} hafta önce`;
    return `${Math.ceil(diffDays / 30)} ay önce`;
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'Yüksek': return 'bg-red-100 text-red-800 border-red-200';
      case 'Orta': return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'Düşük': return 'bg-green-100 text-green-800 border-green-200';
      default: return 'bg-slate-100 text-slate-800 border-slate-200';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Aktif': return 'bg-success text-white';
      case 'Beklemede': return 'bg-warning text-white';
      case 'Pasif': return 'bg-slate-400 text-white';
      default: return 'bg-slate-400 text-white';
    }
  };

  return (
    <div 
      className={`border border-slate-200 rounded-lg p-4 hover:bg-slate-50 transition-colors cursor-pointer ${
        isSelected ? 'bg-primary/5 border-primary' : 'bg-white'
      } ${isCompact ? 'p-3' : 'p-4'}`}
      onClick={() => onSelect(contact)}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3 flex-1">
          {/* Avatar */}
          <div className="w-10 h-10 bg-slate-200 rounded-full flex items-center justify-center flex-shrink-0">
            <Icon name="User" size={20} color="var(--color-text-secondary)" />
          </div>

          {/* Contact Info */}
          <div className="flex-1 min-w-0">
            <div className="flex items-center space-x-2 mb-1">
              <h3 className="text-sm font-medium text-slate-900 truncate">
                {contact?.name}
              </h3>
              {contact?.priority && (
                <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full border ${getPriorityColor(contact?.priority)}`}>
                  {contact?.priority}
                </span>
              )}
            </div>
            
            <div className="flex items-center space-x-4 text-xs text-slate-600">
              <span className="flex items-center">
                <Icon name="Phone" size={12} className="mr-1" />
                {contact?.phone}
              </span>
              {contact?.company && (
                <span className="flex items-center truncate">
                  <Icon name="Building" size={12} className="mr-1" />
                  {contact?.company}
                </span>
              )}
            </div>

            {!isCompact && (
              <div className="flex items-center space-x-4 mt-1 text-xs text-slate-500">
                <span>Son İletişim: {formatLastContact(contact?.lastContact)}</span>
                <div className="flex items-center">
                  <div className={`w-2 h-2 rounded-full mr-1 ${getStatusColor(contact?.status)}`} />
                  <span>{contact?.status}</span>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center space-x-2 ml-4">
          <Button
            variant="outline"
            size="sm"
            onClick={(e) => {
              e?.stopPropagation();
              onCall(contact);
            }}
            iconName="Phone"
            className="text-success hover:text-success hover:border-success"
          >
            Ara
          </Button>
          
          <Button
            variant="ghost"
            size="sm"
            onClick={(e) => {
              e?.stopPropagation();
              onEdit(contact);
            }}
            iconName="Edit"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactListItem;